// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"0934b7e6","118":"3290cac7","428":"3c3996b0","507":"ce821372","710":"cd8acdc2","888":"68e34abc"}[chunkId] + ".chunk.css";
};